import React from "react";
import { useEffect, useState } from "react";
import contractBuild from './build/Lottery.json';
import Contract from './components/Contract';
import { networkDefault, networkList } from "./components/constants";
import { getCurrentWalletConnected } from "./util/interact.js";
import Web3 from 'web3';
import Backendless from "backendless";

const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY;
const BL_APP_ID = process.env.REACT_APP_BACKEND_APP_ID;
const BL_API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

const App = () => {
  const [web3, setWeb3] = useState();
  const [networkId, setNetworkId] = useState(0);
  const [walletAddress, setWallet] = useState("");
  const [lotteryContract, setLottery] = useState();
  const [status, setStatus] = useState("");
  const [statusVisible, setStatusVisible] = useState(false);
  const [stats, setStats] = useState();
  const [symbol, setSymbol] = useState();
  const [amountPerBet, setAmountPerBet] = useState(0);
  const [explorerName, setExplorerName] = useState("");
  const [explorerUrl, setExplorerUrl] = useState("");
  const [explorerAddressUrl, setExplorerAddressUrl] = useState("");
  const [lotteryStarted, setLotteryStarted] = useState();
  const [enabled, setEnabled] = useState();
  const [lastTimestamp, setLastTimestamp] = useState(0);
  const [genesisTimestamp, setGenesis] = useState(0);


  useEffect(() => {
    Backendless.initApp(BL_APP_ID, BL_API_KEY);
    fetchNetwork();
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (networkId !== 0) {
      if (networkId in networkList) {
        setEnabled(true);
      } else {
        setEnabled(false);
      }
      fectchWeb3();
      fetchNetworkAttrib();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkId]);


  useEffect(() => {

    if (web3) {

      async function fetchLastTimestamp() {
        const lastBlock = await web3.eth.getBlock('latest');
        setLastTimestamp(Number(lastBlock.timestamp));
      }

      async function fetchContract() {
        if (networkId in networkList) {
          const lottery = new web3.eth.Contract(
            contractBuild.abi,
            contractBuild.networks[networkId].address
          );
          setLottery(lottery);
        } else {
          const lottery = new web3.eth.Contract(
            contractBuild.abi,
            contractBuild.networks[networkDefault].address
          );
          setLottery(lottery);
        }
      }

      async function fetchWallet() {
        const {address, status} = await getCurrentWalletConnected();
        setWallet(address)
        showNotification(status);
      }

      async function init() {
        if (!lotteryStarted) {
          fetchLastTimestamp();
        }
        await fetchContract();
        if (networkId in networkList) {
          fetchWallet();
        }
      }
      init();

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [web3]);


  const showNotification = (notification, duration=0) => {
    setStatusVisible(false);
    setStatus(notification);
    setStatusVisible(true);
    if (duration !== 0) {
      setTimeout(() => {
        setStatusVisible(false);
      }, duration);
    }
  }

  const fectchWeb3 = async () => {
    if (networkId in networkList) {
      setWeb3(new Web3(window.ethereum));
    } else {
      setWeb3(new Web3(alchemyKey));
      if (window.ethereum) {
        showNotification(
          <div className="warning">Decentralot is only available on the Polygon Network. Please change your network to continue.
          </div>
        );
      }
    }
  }

  async function fetchNetwork() {
    if (window.ethereum) {
      let web3 = new Web3(window.ethereum);
      let netId = await web3.eth.net.getId();
      setNetworkId(netId);
      addWalletListener();
    } else {
      setNetworkId(-1);
      showNotification(
        <div className="warning">🦊 Metamask is not installed. You need to install it to play:&nbsp;
          <a target="_blank" rel="noreferrer" href="https://metamask.io/download">metamask.io</a>
        </div>
      );      
    }
  }

  function fetchNetworkAttrib() {
    let currentNetwork;
    if (networkId in networkList) {
      currentNetwork = networkList[networkId];
    } else {
      currentNetwork = networkList[networkDefault];
    }

    setSymbol(currentNetwork.symbol);
    setAmountPerBet(currentNetwork.amountPerBet);
    setExplorerName(currentNetwork.explorerName);
    setExplorerUrl(currentNetwork.explorerUrl);
    setExplorerAddressUrl(currentNetwork.explorerAddressUrl);
    setLotteryStarted(currentNetwork.lotteryStarted);
  }

  function addWalletListener() {
    window.ethereum.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        setWallet(accounts[0]);
      } else {
        setWallet("");
      }
    });

    window.ethereum.on("chainChanged", (chainId) => {
      setLotteryStarted(false);
      setLastTimestamp(0);
      setGenesis(0);
      const netId = parseInt(chainId, 16);
      if (netId in networkList) {
        setNetworkId(netId);
        setEnabled(true);
        setStatus("");
      } else {
        setNetworkId(-1);
        setEnabled(false);
        showNotification(
          <div className="warning">Decentralot is only available on the Polygon Network. Please change your network to continue.
          </div>
        );
      }
    });
  }

  function fetchHistory() {
    var dataQueryBuilder = Backendless.DataQueryBuilder.create();
    dataQueryBuilder.setProperties(
      "Sum(nbBets) as nbBets, Sum(winnerAmount) as winnerAmount, Sum(pickerAmount) as pickerAmount, networkId"
    );
    dataQueryBuilder.setGroupBy("networkId");

    Backendless.Data.of("history").find(dataQueryBuilder)
    .then( function(result) {
      let obj = {}
      result.forEach((elt) => {
        obj[elt.networkId] = {
          nbBets: elt.nbBets,
          winnerAmount: elt.winnerAmount,
          pickerAmount: elt.pickerAmount
        }        
      });
      setStats(obj);
    });
  }

  return (
    <div className="App">
      <Contract
        lotteryContract={lotteryContract}
        networkId={networkId}
        walletAddress={walletAddress}
        stats={stats}
        symbol={symbol}
        amountPerBet={amountPerBet}
        explorerName={explorerName}
        explorerUrl={explorerUrl}
        explorerAddressUrl={explorerAddressUrl}
        lotteryStarted={lotteryStarted}
        status={status}
        statusVisible={statusVisible}
        enabled={enabled}
        lastTimestamp={lastTimestamp}
        genesisTimestamp={genesisTimestamp}
        setGenesis={setGenesis}
        setWallet={setWallet}
        setStatus={setStatus}
        showNotification={showNotification}
      />
    </div>
  );

}

export default App;
